// @flow
import React from "react";
import { css } from "styled-components";
import { media } from "@nested/rebrand";
import { ButtonLink } from "@nested/component-library";

import { ResponsiveImage } from "../../components/ResponsiveImage";
import { mediumHeading } from "../../components/Typography/Headings";

import {
  type Props,
  getFirstWord,
  getTextWithoutFirstWord,
  textStyles,
} from "./shared";

const imageWrapperStyles = css`
  align-items: flex-end;
  display: flex;
  justify-content: center;
  max-width: 400px;
  width: 100%;

  img {
    width: 100%;
    object-fit: contain;
  }
`;

const contentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  overflow: hidden;
  padding: 7% 20px;
  position: relative;
  justify-content: center;

  a {
    margin-top: 30px;
    width: fit-content;
  }

  ${media.maxDesktop`
    padding: 110px 20px;
  `}
`;

export const DesktopBuyingSellingSlice = ({
  buyingButtonLabel,
  buyingButtonLink,
  buyingText,
  buyingTitle,
  jointImage,
  sellingButtonLabel,
  sellingButtonLink,
  sellingText,
  sellingTitle,
}: Props) => (
  <div
    css={css`
      ${textStyles}
      display: flex;
      max-width: 1180px;
      margin: 0 auto;

      h3 {
        ${mediumHeading}
        margin-bottom: 0;
        font-size: 2.8vw;
        line-height: 1.3em;

        ${media.maxDesktop`
          font-size: 34px;
          line-height: 44px;
        `}
      }

      p {
        margin-top: 20px;
      }
    `}
  >
    <div
      css={css`
        ${contentWrapperStyles}
        padding-right: 10px;
      `}
    >
      <h3>{sellingTitle}</h3>
      <p>
        <span>{getFirstWord(sellingText)}</span>{" "}
        {getTextWithoutFirstWord(sellingText)}
      </p>
      <ButtonLink
        size="large"
        to={sellingButtonLink?.url || "/"}
        type="primary"
      >
        {sellingButtonLabel || "Missing label"}
      </ButtonLink>
    </div>
    <div css={imageWrapperStyles}>
      <ResponsiveImage src={jointImage?.url} />
    </div>
    <div
      css={css`
        ${contentWrapperStyles}
        align-items: flex-end;
        text-align: right;
        padding-left: 10px;
      `}
    >
      <h3>{buyingTitle}</h3>
      <p>
        <span>{getFirstWord(buyingText)}</span>{" "}
        {getTextWithoutFirstWord(buyingText)}
      </p>
      <ButtonLink size="large" to={buyingButtonLink?.url || "/"} type="primary">
        {buyingButtonLabel || "Missing label"}
      </ButtonLink>
    </div>
  </div>
);
